import React from "react";
import { Phone, Mail } from "lucide-react";
import { BROKER } from "../lib/data";

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-ink text-ivory overflow-hidden"
    >
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold to-transparent" />
      <div className="absolute -top-32 -left-32 w-96 h-96 bg-gold/8 rounded-full blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="relative w-10 h-10 bg-gold flex items-center justify-center font-display text-ink text-lg">Z</span>
              <div>
                <div className="font-display text-ivory text-lg">{BROKER.name}</div>
                <div className="eyebrow text-gold text-[10px]">Life Insurance Broker</div>
              </div>
            </div>
            <p className="mt-6 text-ivory/55 text-sm font-light leading-relaxed max-w-md">
              Independent broker representing twelve of the most trusted, BBB-rated carriers in
              America. Protecting families — one policy, one promise at a time.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow text-gold mb-5 text-[11px]">Contact</div>
            <div className="space-y-3 text-sm">
              <a href={BROKER.phoneLink} data-testid="footer-phone" className="flex items-center gap-3 text-ivory/70 hover:text-gold transition-colors">
                <Phone className="w-4 h-4" /> {BROKER.phone}
              </a>
              <a href={BROKER.emailLink} data-testid="footer-email" className="flex items-center gap-3 text-ivory/70 hover:text-gold transition-colors break-all">
                <Mail className="w-4 h-4" /> {BROKER.email}
              </a>
            </div>
          </div>

          <div className="md:col-span-4">
            <div className="eyebrow text-gold mb-5 text-[11px]">Licensing</div>
            <p className="text-ivory/55 text-sm font-light leading-relaxed">
              National Producer Number<br />
              <span className="text-ivory font-medium tracking-wider">NPN {BROKER.npn}</span>
            </p>
            <p className="mt-4 text-ivory/40 text-xs font-light">
              Independent, licensed, and bonded life insurance broker — serving clients across all
              50 U.S. states. Coverage available ages 0–89.
            </p>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-gold/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-ivory/40 text-xs tracking-wider">
            © {new Date().getFullYear()} {BROKER.name}. All rights reserved.
          </p>
          <p className="text-ivory/40 text-xs tracking-wider">
            Protecting Families. Securing Legacies.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
